<template>
  <div class="lista-tipos-selecao">
    <v-card
        :class="{ primary: ehTipoSelecionado(tipo) }"
        :key="tipo.id"
        :disabled="tipo.desabilitado || (ehTipoSelecionado(tipo) && selecionadoBloqueado)"
        @click="selecionarTipo(tipo)"
        class="item-tipo-selecao elevation-0"
        height="100%"
        min-height="170px"
        v-for="tipo in tipos">

      <v-icon
          size="50px"
          :color="definirCorIcone(tipo)"
          :class="{'item__icone rotacionado': tipo.iconeRotacionado}">
        {{ tipo.icon }}
      </v-icon>
      <v-card-text :class="{ 'item__titulo': true, selecionado: ehTipoSelecionado(tipo) }">
        <span v-html="tipo.label"></span>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'ListaTiposSelecao',
  props: {
    tipos: {
      type: Array,
      default: () => {
        return []
      }
    },
    tipoSelecionado: {
      type: String,
      default: ''
    },
    selecionadoBloqueado: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selecionarTipo(tipo) {
      this.$emit('selecionar', tipo)
    },
    ehTipoSelecionado(tipo) {
      return this.tipoSelecionado === tipo.nome
    },
    definirCorIcone(tipo) {
      return this.ehTipoSelecionado(tipo) ? 'white' : 'gray'
    }
  }
}
</script>

<style scoped lang="stylus">

.lista-tipos-selecao
  margin 0 auto 30px
  width 70vw
  display flex
  align-items center
  justify-content center

  .item-tipo-selecao
    align-items center
    text-align center
    display flex
    justify-content center
    flex-direction column
    width 28%
    margin-left 20px
    margin-right 20px
    border 1px solid rgba(0, 0, 0, .12) !important
    text-transform uppercase
    font-size 15px
    color #999
    font-weight bold

    &__icone.rotacionado
      transform rotate(-45deg)

  .item-tipo-selecao:hover
    cursor pointer

  >>>
  .selecionado, .lista-tipos-selecao-card__titulo.selecionado
    color #fff !important

  @media (min-width 1400px)
    .lista-tipos-selecao-linha
      width 70%

  @media (max-width 998px)
    .lista-tipos-selecao-linha
      width 90%

  @media (max-width 768px)
    .lista-tipos-selecao
      &-linha
        width 100%

      &-card
        width 30%

  @media (max-width 600px)
    .lista-tipos-selecao
      &-linha
        flex-direction column

      &-card
        width 100%
        margin 10px 0
</style>